<app-menu [hasChanges]="loadMenu" title="Detalle de cotización nro. {{idCotizacion}}"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="m-2" id="divIni">
    <div class="p-fluid pl-2">
        <p>Esta cotización corresponde al cliente <span class="uppercase font-semibold cursor-pointer"
                (click)="divInfoClient=!divInfoClient;">{{formClient.controls.razonSocial.value?.replace('/','')
                !='NA'?formClient.controls.razonSocial.value:
                formClient.controls.nombres.value}}</span> creada el día de {{lsInfoCotizacion.fechaCreacion | date }} y
            en proceso <b>{{lsInfoCotizacion.estado==1?'actual':'finalizado'}}</b>.</p>
    </div>
    <div>
        <div *ngIf="divInfoClient">
            <form [formGroup]="formClient">
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label class="pb-2">Tipo de identificación <span class="text-xs text-red-700">*</span></label>
                        <p-select [options]="listIdentificationType" optionLabel="descripcion" size="small"
                            placeholder="Tipo de identificación" formControlName="tipo"
                            class="disabledFillFields"></p-select>
                    </div>
                    <div class="col-12 md:col-6">

                        <label class="pb-2">Nro. de identificación <span class="text-xs text-red-700">*</span> <span
                                class="text-xs" *ngIf="formClient.value.tipo?.idTipoIdentificacion ==3">
                                Ingrese la información sin puntos y sin dígito de verificación</span></label>
                        <div class="p-inputgroup">
                            <input pInputText type="text" class="w-full disabledFillFields" pSize="small"
                                placeholder="Nro. de Identificación" formControlName="identificacion"
                                autocomplete="off">
                            <div class="p-inputgroup-addon">
                                <label>{{digito??''}}</label>
                            </div>
                        </div>

                    </div>
                    <div class="col-12" *ngIf="formClient.value.tipo?.idTipoIdentificacion ==3">
                        <label class="pb-2">Razón Social <span class="text-xs text-red-700">*</span></label>
                        <input pInputText type="text" class="w-full uppercase disabledFillFields" pSize="small"
                            placeholder="Razon Social" formControlName="razonSocial" autocomplete="off">
                    </div>
                    <div class="col-12">
                        <label class="pb-2">Contacto <span class="text-xs text-red-700">*</span></label>
                        <input pInputText type="text" class="w-full uppercase disabledFillFields" pSize="small"
                            placeholder="Nombres y Apellidos" formControlName="nombres" autocomplete="off">
                    </div>
                    <div class="col-12">
                        <label class="pb-2">Correo electrónico <span class="text-xs text-red-700">*</span></label>
                        <input pInputText type="text" class="w-full lowercase disabledFillFields" pSize="small"
                            placeholder="Correo Electrónico" formControlName="correo">
                    </div>
                    <div class="col-12">
                        <label class="pb-2">Dirección</label>
                        <input pInputText type="text" class="w-full disabledFillFields" placeholder="Dirección"
                            pSize="small" formControlName="direccion">
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="pb-2">Departamento</label>
                        <p-select [options]="listDptos" optionLabel="nombreDepartamento" placeholder="Departamento"
                            formControlName="departamento" (onChange)="loadCities()" size="small"
                            class="disabledFillFields"></p-select>
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="pb-2">Ciudad</label>
                        <p-select [options]="listCities" optionLabel="nombreCiudad" placeholder="Ciudad" size="small"
                            formControlName="ciudad" class="disabledFillFields"></p-select>
                    </div>
                    <div class="col-12">
                        <label class="pb-2">Nro. de teléfono</label>
                        <input pInputText type="text" class="w-full disabledFillFields" placeholder="Nro. de celular"
                            pSize="small" formControlName="telefono">
                    </div>
                </div>
            </form>
        </div>
        <div *ngIf="infoShipping[0]!=''">
            <h4 class="uppercase">Información de envío</h4>
            <p>
                <b>Contacto</b>: {{infoShipping[0] ??""}}<br>
                <b>Dirección</b>: {{infoShipping[1] ??""}}<br>
                <b>Ciudad</b>: {{cityShippingSelected?.idDepartamentoNavigation?.nombreDepartamento ??""}} -
                {{cityShippingSelected?.nombreCiudad ??""}}
            </p>
        </div>
        <hr>
        <div class="w-full text-center">
            <h3 class="uppercase">Listado de productos cotizados</h3>
        </div>
        <div class="flex flex-wrap">
            <!--Listado de productos-->
            <div class="w-full md:w-9">
                <div class="gap-2 {{last?'mb-5':''}}"
                    *ngFor="let item of lsInfoCotizacion.detalle; let $index=index; let last=last">
                    <div class="flex flex-column sm:flex-row sm:align-items-center p-4 gap-3"
                        [ngClass]="{ 'border-top-1 border-700 ': !$index }">
                        <div class="md:w-10rem relative">
                            <img class="block xl:block mx-auto border-round w-full"
                                [src]="item.infoProducto.productoImagenes.length > 0 ? urlImages + item.infoProducto.productoImagenes[0].ubicacion:'assets/img/noImg.png'"
                                [alt]="item.infoProducto.productoImagenes.length > 0 ? item.infoProducto.productoImagenes[0].etiqueta:item.descripcionCorta" />
                            <p-tag *ngIf="this.lsInfoCotizacion.estado==1" [value]="item.inventoryNumber"
                                severity="success" class="absolute" [style.left.px]="4" [style.top.px]="4" />
                        </div>
                        <div
                            class="md:w-5 flex flex-column md:flex-row justify-content-between md:align-items-center flex-1 gap-2">
                            <div
                                class="md:w-6  flex flex-row md:flex-column justify-content-between align-items-start gap-2">
                                <div>
                                    <span class="font-medium text-secondary text-sm">{{
                                        item.infoProducto.categorizacion[0]?.nameCategory }} / {{
                                        item.infoProducto.categorizacion[1]?.nameCategory }} </span><br>
                                    <span class="font-medium text-secondary text-sm">SKU:
                                        {{item.infoProducto.codBarras}} </span>
                                    <div class="text-lg font-medium text-surface-700 mt-2">{{
                                        item.infoProducto.descripcionCorta}}
                                    </div>
                                    <span class="font-medium text-secondary text-sm">{{ item.infoProducto.marca
                                        }}</span>
                                </div>

                                <div class="hidden md:flex" *ngIf="this.lsInfoCotizacion.estado==1">
                                    <a class="p-button p-button-link p-0 m-0"
                                        (click)="item.cantidad=0;showDialogItem(item, $index);getTotal()">Eliminar</a>
                                </div>
                            </div>
                            <div class="md:w-3 flex flex-column md:align-items-end gap-1">
                                <div class="flex flex-column gap-2">
                                    <div *ngIf="this.lsInfoCotizacion.estado !=1" class="text-center">
                                        <small>
                                            Cantidad
                                        </small><br><span class="text-xl font-semibold text-surface-700">{{
                                            item.cantidad | number }}</span>
                                    </div>
                                    <div *ngIf="this.lsInfoCotizacion.estado==1">
                                        <label for="username">Cantidad</label>
                                        <p-inputNumber inputId="integeronly" [(ngModel)]="item.cantidad"
                                            [showButtons]="true" [inputStyle]="{'width':'110px'}"
                                            buttonLayout="horizontal" spinnerMode="horizontal" [min]="0" [max]="1000"
                                            (onInput)="showDialogItem(item, $index);">
                                            <ng-template #incrementbuttonicon>
                                                <span class="pi pi-plus"></span>
                                            </ng-template>
                                            <ng-template #decrementbuttonicon>
                                                <span class="pi pi-minus"></span>
                                            </ng-template>
                                        </p-inputNumber>
                                    </div>
                                    <!--Inventario de los productos-->
                                    <div class="flex flex-column gap-2">
                                        <div class="text-xs " *ngFor="let invSKU of item.inventory; let count=count;">
                                            <div>{{invSKU.nombreTienda}} - {{invSKU.tiendaProductos[0].cantidadEnMano |
                                                number}}</div>
                                        </div>
                                    </div>
                                    <div class="md:hidden" *ngIf="this.lsInfoCotizacion.estado==1">
                                        <a class="p-button p-button-link p-0 m-0"
                                            (click)="item.cantidad=0;showDialogItem(item, $index);getTotal()">Eliminar</a>
                                    </div>
                                </div>

                            </div>
                            <div class="w-full md:w-5 flex flex-row justify-content-between gap-1">
                                <div class="md:w-6 flex flex-column md:align-items-end gap-1">
                                    <small>
                                        Precio (con IVA)
                                    </small>
                                    <section id="sectionChangePrice"
                                        class="flex flex-row justify-content-between align-items-center">
                                        <span class="text-xs font-semibold text-surface-700">
                                            <span class="text-xs block" *ngIf="item.precio > item.precioPromocion"> <del> {{
                                                    item.precio | currency }}</del></span>{{
                                            item.precioPromocion | currency }}</span>
                                        <span class="cursor-pointer bg-green-700 p-1 border-round"
                                            *ngIf="this.lsInfoCotizacion.estado==1"><i
                                                class="pi pi-pencil text-white text-xs"
                                                (click)="openDialogCambioPrecio(item, $index)"></i></span>
                                    </section>
                                </div>
                                <div class="md:w-6 flex flex-column md:align-items-end gap-1">
                                    <small> Total</small>
                                    <span class="text-xl font-semibold text-surface-700">{{
                                        item.precioPromocion * item.cantidad | currency
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div [innerHTML]="item.message"></div>
                </div>
            </div>
            <!--Resumen de la cotización-->
            <div class="w-full md:w-3 bg-gray-50 text-center p-3 border-round">
                <div class="sticky top-0 pt-3">
                    <h4 class="uppercase">Resumen de la cotización</h4>
                    <div class="flex flex-wrap">
                        <div class="w-full flex flex-wrap pb-2">
                            <div class="w-8 text-left uppercase">
                                <p class="m-0">Cantidad de Artículos:</p>
                            </div>
                            <div class="w-4 text-right uppercase">
                                <p class="m-0">{{lsInfoCotizacion?.detalle?.length}}</p>
                            </div>
                        </div>
                        <div class="w-full flex flex-wrap pb-2">
                            <div class="w-8 text-left uppercase">
                                <p class="m-0">SUBTOTAL:</p>
                            </div>
                            <div class="w-4 text-right uppercase">
                                <p class="m-0">{{totales[0] | currency}}</p>
                            </div>
                        </div>

                        <div class="w-full flex flex-wrap pb-2">
                            <div class="w-8 text-left uppercase">
                                <p class="m-0">FLETE (SIN IVA):</p>
                            </div>
                            <div class="w-4 text-right uppercase">
                                <p class="m-0">{{this.cobroFlete.subtotal ?? 0| currency}}&nbsp;<i
                                        class="pi pi-pencil text-green-500 cursor-pointer"
                                        (click)="displayFlete=true;"></i></p>
                            </div>
                        </div>
                        <div class="w-full flex flex-wrap pb-2">
                            <div class="w-8 text-left uppercase">
                                <p class="m-0">IVA:</p>
                            </div>
                            <div class="w-4 text-right uppercase">
                                <p class="m-0">{{totales[1] | currency}}</p>
                            </div>
                        </div>
                        <div class="w-full flex flex-wrap pb-2">
                            <div class="w-8 text-left uppercase">
                                <h3 class="text-primary">TOTAL</h3>
                            </div>
                            <div class="w-4 text-right uppercase">
                                <h3 class="text-primary">{{totales[0] + totales[1] + this.cobroFlete.subtotal
                                    +this.cobroFlete.impuesto | currency}}</h3>
                            </div>
                        </div>

                        <div class="w-full pb-3" *ngIf="listCommercialPolicy.length >1">
                            <div class="p-inputgroup">
                                <div class="p-inputgroup-addon"><i class="pi pi-exclamation-circle"></i></div>
                                <p-select [options]="listCommercialPolicy" [(ngModel)]="selectedCommercialPolicy"
                                    optionLabel="descripcion"
                                    placeholder="Seleccione la política comercial a aplicar" />
                            </div>
                        </div>
                        <div class="w-full" *ngIf="this.lsInfoCotizacion.estado==1">
                            <button pButton icon="pi pi-check-circle" class="p-button p-button-success"
                                label="Continuar" (click)="continue()"></button>
                        </div>
                        <div class="w-full" *ngIf="this.lsInfoCotizacion.estado==1">
                            <button pButton icon="pi pi-check-circle" class="p-button p-button-link w-auto"
                                label="Seguir incluyendo productos o información de despacho"
                                (click)="reInsertProducts()"></button>
                        </div>
                        <div class="w-full" *ngIf="this.lsInfoCotizacion.estado !=1">
                            <button pButton icon="pi pi-check-circle" class="p-button p-button-link p-0 m-0"
                                label="Crear nueva cotización" (click)="returnHistory()"></button>
                        </div>

                        <div class="w-full p-2"
                            *ngIf="(this.lsInfoCotizacion.estado==2) && (!(this.lsInfoCotizacion.paymentMade ?? false)) && (!(this.lsInfoCotizacion.idEstadoSeguimientoCotizacionNavigation?.readyForImport ?? false))">
                            <button pButton icon="pi pi-pencil" class="p-button text-blue-500 p-button-link p-0 m-0"
                                label="Editar Cotización" (click)="editQuotation()"></button>
                        </div>
                        <div class="w-full p-2" *ngIf="this.lsInfoCotizacion.estado==2">
                            <button pButton icon="pi pi-check-circle"
                                class="p-button text-primary p-button-link p-0 m-0" label="Exportar Cotización"
                                (click)="getReportQuotation()"></button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <h4 class="uppercase cursor-pointer" (click)="showCommercialPolicy= !showCommercialPolicy">
            {{!showCommercialPolicy ?'Ver':'Ocultar'}} Política
            comercial</h4>
    </div>
    <div *ngIf="showCommercialPolicy" class="p-3">
        <span [innerHTML]="this.lsInfoCotizacion.idPoliticaComercialNavigation?.flete"></span>
        <span [innerHTML]="this.lsInfoCotizacion.idPoliticaComercialNavigation?.tiempoEntrega"></span>
        <span [innerHTML]="this.lsInfoCotizacion.idPoliticaComercialNavigation?.adicional1"></span>
        <span [innerHTML]="this.lsInfoCotizacion.idPoliticaComercialNavigation?.medioPago"></span>
        <span [innerHTML]="this.lsInfoCotizacion.idPoliticaComercialNavigation?.piedePagina"></span>
    </div>
</div>

<p-dialog header="Confirmación de Eliminación" [(visible)]="divShowDeleteSku" [modal]="true">
    <p-header>¿Desea eliminar el producto "{{selectedItem?.infoProducto?.descripcionCorta}}"?</p-header>
    <ng-template #footer>
        <button pButton icon="pi pi-check-circle" class="p-button p-button-success" label="SI"
            (click)="updateQSKU(selectedItem, this.indexSelectedSKU??-1)"></button> &nbsp;<button pButton
            icon="pi pi-times-circle" class="p-button p-button-danger" label="NO"
            (click)="divShowDeleteSku=false;selectedItem.cantidad=1; getTotal()"></button>
    </ng-template>
</p-dialog>


<p-dialog header="Confirmación de Finalización" [(visible)]="divShowEndQuotation" [modal]="true">
    ¿Desea finalizar la cotización Nro. {{idCotizacion}} correspondiente al cliente
    <span class="uppercase font-semibold cursor-pointer"
        (click)="divInfoClient=!divInfoClient;">{{formClient.controls.razonSocial.value
        !='NA'?formClient.controls.razonSocial.value:
        formClient.controls.nombres.value}}</span>?

    <div class="w-full flex flex-column">
        <p-accordion [activeIndex]="0">
            <p-accordionTab header="Exportar a PDF">
                <button pButton icon="pi pi-file-export" class="p-button p-button-success" label="Exportar"
                    (click)="endQuotation(1)"></button>
            </p-accordionTab>
            <p-accordionTab header="Enviar por correo">
                <div class="p-2 flex flex-column">
                    <input type="email" pInputText placeholder="Ingrese el correo electrónico"
                        [(ngModel)]="emailShipping" autocomplete="false">
                    <small>Correo a enviar la cotización generadá, si se requiere más de un correo puede separarlos por
                        punto y coma (;) </small>
                </div>
                <button pButton icon="pi pi-file-export" class="p-button p-button-success"
                    label="Enviar cotización por correo" (click)="endQuotation(2)"></button>
            </p-accordionTab>
        </p-accordion>

    </div>
    <div><span [innerHTML]="msgTerminationQuotation"></span></div>
    <ng-template #footer>
        <button pButton icon="pi pi-times-circle" class="p-button p-button-danger" label="Cerrar"
            (click)="divShowEndQuotation=false"></button>
    </ng-template>
</p-dialog>

<p-dialog header="CAMBIO DE PRECIO - PRODUCTO" [(visible)]="displayPrecio" [modal]="true">
    <h4>Relacione el precio del producto</h4>
    <p><b>{{itemSKU.descripcionCorta}}</b><br>
        <b>Código producto :</b> {{itemSKU.referencia}} - {{itemSKU.codBarras}}<br>
    </p>
    <div class="flex flex-wrap gap-4 pb-2">
        <div class="flex items-center">
            <p-radioButton name="optionNumber" value="1" (onClick)="itemSKU.precioFinal=null;"
                [(ngModel)]="priceDiscountType" inputId="ingredient1" />
            <label for="ingredient1" class="ml-2">Precio</label>
        </div>

        <div class="flex items-center">
            <p-radioButton name="optionNumber" value="2" (onClick)="itemSKU.precioFinal=null;"
                [(ngModel)]="priceDiscountType" inputId="ingredient2" />
            <label for="ingredient2" class="ml-2">Porcentaje <span class="text-xs">de descuento</span></label>
        </div>
    </div>

    <p-inputNumber placeholder="{{priceDiscountType==1?'Relacione precio nuevo':'Relacione porcentaje'}}" locale="en-US"
        prefix="{{priceDiscountType==1?'$':''}}" suffix="{{priceDiscountType==2?'%':''}}"
        [(ngModel)]="itemSKU.precioFinal"></p-inputNumber>
    <ng-template #footer>
        <button pButton icon="pi pi-check" label="Procesar cambio" class="p-button p-button-success"
            (click)="setCambioPrecio()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="ACTUALIZAR FLETE" [(visible)]="displayFlete" [modal]="true">
    <h4>Relacione el valor del flete con IVA</h4>
    <p-inputNumber placeholder="Precio producto" mode="currency" currency="USD" locale="en-US"
        [(ngModel)]="shippingValue"></p-inputNumber>
    <ng-template #footer>
        <button pButton icon="pi pi-check" label="Procesar cambio" class="p-button p-button-success"
            (click)="setShippingValue()"></button>
    </ng-template>
</p-dialog>
<p-toast></p-toast>